import { queryTableName } from '@/interface/chat';

export const queryTableNameUtil = (
  query: string | queryTableName,
  table: string | queryTableName,
  expSystemKey: number,
): { sqlQuery: string; tableName: string } => {
  let sqlQuery = '';
  let tableName = '';
  if (query && typeof query === 'object') {
    sqlQuery = expSystemKey === 6 && query.CAN ? query.CAN : query.US;
  }
  if (table && typeof table === 'object') {
    tableName = expSystemKey === 6 && table.CAN ? table.CAN : table.US;
  }
  return { sqlQuery, tableName };
};
